/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './index.scss'

// 首页、服务保障页、卖车页
// 首页banner图大小：1500*350， 首页banner 图多个
// 卖车页banner图大小：1190*450
// 服务保障页banner图大小：1190*612
const Banner = ({ bannerdata, children }) => {
  const wrapperStyle = { backgroundColor: bannerdata.banner_background_color }
  const bannerStyle = { background: `url('${bannerdata.banner}') center no-repeat ${bannerdata.banner_background_color}` }
  return (
    <div className={styles['r-banner']} style={wrapperStyle}>
      <div className="r-banner__container" style={bannerStyle}>
        {children}
      </div>
    </div>
  )
}

export default Banner

Banner.propTypes = {
  children: PropTypes.any,
  bannerdata: PropTypes.any
}

Banner.defaultProps = {
  children: null,
  bannerdata: {}
}